import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { COLORS } from "../../../Constants/colors";

const CardWrapper = styled.div`
  background-color: ${COLORS.cardBackground || "#fff"};
  color: ${COLORS.textPrimary};
  position: relative;
  min-height: 700px;
  overflow: hidden;
  border-radius: 20px;
  cursor: pointer;
  width: 100%;
  box-shadow: ${COLORS.shadowColor};
  border: 1px solid ${COLORS.border};
  transition: transform 0.4s ease;
  &:hover {
    transform: translateY(-4px);
  }

  @media (max-width: 1024) {
    height: 1200px;
  }
`;

// const ImageWrapper = styled.div`
//   position: absolute;
//   top: 0;
//   left: ${({ isHovered }) => (isHovered ? "-100%" : "0")};
//   width: 100%;
//   height: 100%;
//   background-image: ${({ image }) => `url(${image})`};
//   background-size: cover;
//   background-position: center;
//   transition: left 0.6s ease;
//   z-index: 1;
// `;
const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: ${({ isHovered }) => (isHovered ? "-100%" : "0")};
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: left 0.6s ease;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
`;

const Overlay = styled.div`
  position: relative;
  z-index: 2;
  padding: 28px 24px 16px;
  background: ${({ isHovered }) =>
    isHovered
      ? "transparent"
      : `linear-gradient(to bottom, rgba(18, 18, 18, 0.92), transparent)`};

  @media (prefers-color-scheme: dark) {
    background: ${({ isHovered }) =>
      isHovered
        ? "transparent"
        : `linear-gradient(to bottom, rgba(18, 18, 18, 0.92), transparent)`};
  }

  transition: background 0.3s ease-in-out;
`;

const CardTitle = styled.h3`
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ isHovered }) =>
    isHovered ? COLORS.primary : COLORS.buttonText};
  transition: color 0.3s ease;
  margin-bottom: 8px;
`;

const SlidingContent = styled.div`
  position: absolute;
  top: 120px;
  left: ${({ isHovered }) => (isHovered ? "0" : "100%")};
  width: 90%;
  height: calc(100% - 130px);
  transition: left 0.6s ease;
  padding: 0px 28px;
  overflow-y: auto;
  z-index: 3;
  border-left: 4px solid ${COLORS.primary};

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.primary};
    border-radius: 10px;
  }
`;

const Description = styled.div`
  color: ${COLORS.textSecondary};
  font-size: 1.4rem;
  line-height: 1.4;
  margin-bottom: 20px;

  p {
    margin-bottom: 1rem;
  }
`;

const ExpandButton = styled.a`
  display: inline-block;
  padding: 10px 16px;
  border: 2px solid ${COLORS.primary};
  color: ${COLORS.primary};
  background: transparent;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: ${COLORS.primary};
    color: ${COLORS.buttonText};
  }
`;

const Card = ({ image, label, title, description, link }) => {
  const scrollRef = useRef();
  const [isHovered, setHovered] = useState(false);

  useEffect(() => {
    if (!isHovered && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [isHovered]);

  return (
    <CardWrapper
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* <ImageWrapper image={image} isHovered={isHovered} /> */}
      <ImageWrapper isHovered={isHovered}>
        <img src={image} alt={title} />
      </ImageWrapper>

      <Overlay isHovered={isHovered}>
        <CardTitle isHovered={isHovered}>{title}</CardTitle>
      </Overlay>

      <SlidingContent isHovered={isHovered} ref={scrollRef}>
        <Description>
          {description
            .split("###")
            .map((para, i) => (
              <p key={i}>{para.trim()}</p>
            ))}
        </Description>
        {/* {link && (
          <ExpandButton href={link} target="_blank" rel="noopener noreferrer">
            Read More →
          </ExpandButton>
        )} */}
      </SlidingContent>
    </CardWrapper>
  );
};

export default Card;
